import React, { useEffect, useState, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Home, Building2, Users, HandshakeIcon, Mail, ChevronRight, ChevronLeft, ChevronsRight, X, ChevronDown, Database, UsersRound, Megaphone, Flame, UserCog, TrendingUp, Briefcase, Activity, Calendar, Building, User, Target, Plus, Sparkles, Newspaper, Search } from 'lucide-react';
import { useSidebar } from '../contexts/SidebarContext';
const crmMenuItems = [{
  icon: Home,
  label: 'Dashboard',
  path: '/'
}, {
  icon: Building2,
  label: 'Immobili',
  path: '/properties'
}, {
  icon: Users,
  label: 'Clienti',
  path: '/clienti',
  subItems: [{
    icon: Building,
    label: 'Aziende',
    path: '/clienti/aziende'
  }, {
    icon: User,
    label: 'Referenti',
    path: '/clienti/referenti'
  }, {
    icon: Target,
    label: 'Esigenze',
    path: '/clienti/esigenze'
  }]
}, {
  icon: HandshakeIcon,
  label: 'Trattative',
  path: '/deals'
}, {
  icon: Calendar,
  label: 'Calendario',
  path: '/calendar'
}];
const teamMenuItems = [{
  icon: Home,
  label: 'Dashboard Team',
  path: '/team'
}, {
  icon: UsersRound,
  label: 'Membri del Team',
  path: '/team/members'
}, {
  icon: TrendingUp,
  label: 'Performance',
  path: '/team/performance'
}, {
  icon: Briefcase,
  label: 'Carichi di Lavoro',
  path: '/team/workload'
}, {
  icon: Activity,
  label: 'Attività',
  path: '/team/activities'
}];
const campaignsMenuItems = [{
  icon: Mail,
  label: 'Campagne Inviate',
  path: '/campaigns'
}, {
  icon: Plus,
  label: 'Nuova Campagna',
  path: '/campaigns/new'
}, {
  icon: Sparkles,
  label: 'Automazione AI',
  path: '/campaigns/automation'
}, {
  icon: HandshakeIcon,
  label: 'Email Trattative',
  path: '/campaigns/deals'
}];
const utilityMenuItems = [{
  icon: Target,
  label: 'Needs Matching',
  path: '/utility/needs-matching'
}, {
  icon: Building,
  label: 'Property Matching',
  path: '/utility/property-matching'
}, {
  icon: Search,
  label: 'Street Analysis',
  path: '/utility/street-analysis'
}, {
  icon: TrendingUp,
  label: 'Strategy Planner',
  path: '/utility/strategy-planner'
}];
const areaOptions = [{
  value: 'CRM',
  label: 'CRM',
  icon: Database
}, {
  value: 'Gestione Team',
  label: 'Gestione Team',
  icon: UsersRound
}, {
  value: 'Gestione Campagne',
  label: 'Gestione Campagne',
  icon: Megaphone
}, {
  value: 'Gestione Annunci',
  label: 'Gestione Annunci',
  icon: Newspaper
}, {
  value: 'Utility',
  label: 'Utility',
  icon: Flame
}];
export function Sidebar() {
  const {
    mode,
    setMode,
    isExpanded,
    setIsExpanded,
    isMobileMenuOpen,
    setIsMobileMenuOpen
  } = useSidebar();
  const navigate = useNavigate();
  const [selectedArea, setSelectedArea] = useState('CRM');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const mobileDropdownRef = useRef<HTMLDivElement>(null);
  const selectedAreaOption = areaOptions.find(opt => opt.value === selectedArea);
  const SelectedIcon = selectedAreaOption?.icon || Database;
  const menuItems = selectedArea === 'Gestione Team' ? teamMenuItems : selectedArea === 'Gestione Campagne' ? campaignsMenuItems : selectedArea === 'Utility' ? utilityMenuItems : crmMenuItems;
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
      if (mobileDropdownRef.current && !mobileDropdownRef.current.contains(event.target as Node)) {
        setIsMobileDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const handleAreaChange = (area: string) => {
    setSelectedArea(area);
    setIsDropdownOpen(false);
    setIsMobileDropdownOpen(false);
    // Naviga automaticamente alla prima voce del menu dell'area selezionata
    if (area === 'Gestione Campagne') {
      navigate('/campaigns');
    } else if (area === 'Gestione Team') {
      navigate('/team');
    } else if (area === 'Utility') {
      navigate('/utility/needs-matching');
    } else if (area === 'CRM') {
      navigate('/');
    }
  };
  const handleMouseEnter = () => {
    if (mode === 'hover' && window.innerWidth >= 768) {
      setIsExpanded(true);
    }
  };
  const handleMouseLeave = () => {
    if (mode === 'hover' && window.innerWidth >= 768) {
      setIsExpanded(false);
    }
  };
  const cycleMode = () => {
    if (mode === 'hover') {
      setMode('expanded');
      setIsExpanded(true);
    } else if (mode === 'expanded') {
      setMode('collapsed');
      setIsExpanded(false);
    } else {
      setMode('hover');
      setIsExpanded(false);
    }
  };
  const getModeIcon = () => {
    switch (mode) {
      case 'hover':
        return ChevronsRight;
      case 'expanded':
        return ChevronLeft;
      case 'collapsed':
        return ChevronRight;
    }
  };
  const getModeLabel = () => {
    switch (mode) {
      case 'hover':
        return 'Espandi al passaggio';
      case 'expanded':
        return 'Mantieni espansa';
      case 'collapsed':
        return 'Mantieni compressa';
    }
  };
  const ModeIcon = getModeIcon();
  const shouldExpand = mode === 'expanded' || mode === 'hover' && isExpanded;
  const handleMobileMenuItemClick = () => {
    setIsMobileMenuOpen(false);
  };
  const toggleMenu = (path: string) => {
    setExpandedMenus(prev => prev.includes(path) ? prev.filter(p => p !== path) : [...prev, path]);
  };
  const renderMenuItem = (item: any, isMobile: boolean = false) => {
    const hasSubItems = item.subItems && item.subItems.length > 0;
    const isExpanded = expandedMenus.includes(item.path);
    const Icon = item.icon;
    if (hasSubItems) {
      return <div key={item.path} data-id="element-140">
          <button onClick={() => toggleMenu(item.path)} className={`flex items-center w-full transition-colors text-gray-300 hover:bg-white/5 rounded-full h-12 ${isMobile || shouldExpand ? 'px-4' : 'px-4'}`} data-id="element-141">
            <div className="w-4 h-4 flex items-center justify-center flex-shrink-0" data-id="element-142">
              <Icon className="w-4 h-4" data-id="element-143" />
            </div>
            {(isMobile || shouldExpand) && <>
                <span className="ml-3 text-sm font-normal whitespace-nowrap flex-1 text-left" data-id="element-144">
                  {item.label}
                </span>
                <ChevronDown className={`w-4 h-4 flex-shrink-0 transition-transform ${isExpanded ? 'rotate-180' : ''}`} data-id="element-145" />
              </>}
          </button>
          {isExpanded && (isMobile || shouldExpand) && <div className="ml-4 mt-1 space-y-1" data-id="element-146">
              {item.subItems.map((subItem: any) => {
            const SubIcon = subItem.icon;
            return <NavLink key={subItem.path} to={subItem.path} onClick={isMobile ? handleMobileMenuItemClick : undefined} className={({
              isActive
            }) => `flex items-center px-4 rounded-full transition-colors h-10 ${isActive ? 'bg-[#1388ad] text-white' : 'text-gray-300 hover:bg-white/5'}`} data-id="element-147">
                    <div className="w-3.5 h-3.5 flex items-center justify-center flex-shrink-0" data-id="element-148">
                      <SubIcon className="w-3.5 h-3.5" data-id="element-149" />
                    </div>
                    <span className="ml-3 text-sm font-normal whitespace-nowrap" data-id="element-150">
                      {subItem.label}
                    </span>
                  </NavLink>;
          })}
            </div>}
        </div>;
    }
    return <NavLink key={item.path} to={item.path} end={true} onClick={isMobile ? handleMobileMenuItemClick : undefined} className={({
      isActive
    }) => `flex items-center transition-colors rounded-full h-12 ${isMobile || shouldExpand ? 'px-4' : 'px-4'} ${isActive ? 'bg-[#1388ad] text-white' : 'text-gray-300 hover:bg-white/5'}`} data-id="element-151">
        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0" data-id="element-152">
          <Icon className="w-4 h-4" data-id="element-153" />
        </div>
        {(isMobile || shouldExpand) && <span className="ml-3 text-sm font-normal whitespace-nowrap" data-id="element-154">
            {item.label}
          </span>}
      </NavLink>;
  };
  return <>
      {/* Mobile Drawer Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 bg-black/50 z-40 md:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-155" />}
      {/* Mobile Drawer */}
      <div className={`fixed left-0 top-0 h-screen bg-[#1d3a49] text-white flex-col transition-transform duration-300 z-50 w-64 md:hidden ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-156">
        <div className="p-6 border-b border-white/10 flex items-center justify-between h-16 flex-shrink-0" data-id="element-157">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vpHtL3NoPEAy2mA5edVSq9/EDARES-2-1_%281%29.png" alt="Edares Logo" className="h-12 w-auto" data-id="element-158" />
          <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 hover:bg-white/5 rounded-full transition-colors" data-id="element-159">
            <X className="w-5 h-5" data-id="element-160" />
          </button>
        </div>
        {/* Area Selector - Mobile */}
        <div className="px-4 pt-4 pb-1 h-[68px] flex-shrink-0" ref={mobileDropdownRef} data-id="element-161">
          <div className="relative" data-id="element-162">
            <button onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)} className="w-full px-4 py-2.5 pr-10 bg-white/10 text-white text-sm font-normal rounded-full border border-white/20 hover:bg-white/15 focus:outline-none focus:ring-2 focus:ring-[#1388ad] transition-colors flex items-center gap-2" data-id="element-163">
              <SelectedIcon className="w-4 h-4 flex-shrink-0" data-id="element-164" />
              <span className="flex-1 text-left whitespace-nowrap overflow-hidden text-ellipsis" data-id="element-165">
                {selectedAreaOption?.label}
              </span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isMobileDropdownOpen ? 'rotate-180' : ''}`} data-id="element-166" />
            </button>
            {isMobileDropdownOpen && <div className="absolute top-full left-0 right-0 mt-2 bg-[#1d3a49] border border-white/20 rounded-2xl overflow-hidden shadow-xl z-50" data-id="element-167">
                {areaOptions.map(option => {
              const OptionIcon = option.icon;
              return <button key={option.value} onClick={() => handleAreaChange(option.value)} className={`w-full px-4 py-3 text-left text-sm flex items-center gap-2 transition-colors whitespace-nowrap ${selectedArea === option.value ? 'bg-[#1388ad] text-white' : 'text-gray-300 hover:bg-white/5'}`} data-id="element-168">
                      <OptionIcon className="w-4 h-4 flex-shrink-0" data-id="element-169" />
                      <span data-id="element-170">{option.label}</span>
                    </button>;
            })}
              </div>}
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-2 overflow-y-auto" data-id="element-171">
          {menuItems.map(item => renderMenuItem(item, true))}
        </nav>
      </div>
      {/* Desktop Sidebar */}
      <div className={`fixed left-0 top-0 h-screen bg-[#1d3a49] text-white flex-col transition-[width] duration-200 ease-in-out z-50 hidden md:flex ${shouldExpand ? 'w-64' : 'w-20'}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} data-id="element-172">
        {/* Logo Section - Fixed Height */}
        <div className="h-16 flex-shrink-0 border-b border-white/10 flex items-center px-6 overflow-hidden" data-id="element-173">
          <div className={`h-12 w-full flex items-center ${shouldExpand ? 'justify-start' : 'justify-center'}`} data-id="element-174">
            {shouldExpand ? <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vpHtL3NoPEAy2mA5edVSq9/EDARES-2-1_%281%29.png" alt="Edares Logo" className="h-12 w-auto object-contain" data-id="element-175" /> : <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/e56B954JMM28ufKP45ucTc/logo_edares_small.png" alt="Edares" className="h-8 w-auto object-contain" data-id="element-176" />}
          </div>
        </div>
        {/* Area Selector - Fixed Height */}
        <div className="h-[68px] flex-shrink-0 px-4 pt-4 pb-1 flex items-center justify-center" ref={dropdownRef} data-id="element-177">
          <div className={`transition-all duration-200 ${shouldExpand ? 'w-full' : 'w-auto'}`} data-id="element-178">
            {shouldExpand ? <div className="relative w-full h-10" data-id="element-179">
                <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="w-full h-10 px-4 bg-white/10 text-white text-sm font-normal rounded-full border border-white/20 hover:bg-white/15 focus:outline-none focus:ring-2 focus:ring-[#1388ad] transition-colors flex items-center gap-3" data-id="element-180">
                  <SelectedIcon className="w-4 h-4 flex-shrink-0" data-id="element-181" />
                  <span className="flex-1 text-left whitespace-nowrap overflow-hidden text-ellipsis" data-id="element-182">
                    {selectedAreaOption?.label}
                  </span>
                  <ChevronDown className={`w-4 h-4 flex-shrink-0 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} data-id="element-183" />
                </button>
                {isDropdownOpen && <div className="absolute top-full left-0 right-0 mt-2 bg-[#1d3a49] border border-white/20 rounded-2xl overflow-hidden shadow-xl z-50" data-id="element-184">
                    {areaOptions.map(option => {
                const OptionIcon = option.icon;
                return <button key={option.value} onClick={() => handleAreaChange(option.value)} className={`w-full px-4 py-3 text-left text-sm flex items-center gap-3 transition-colors whitespace-nowrap ${selectedArea === option.value ? 'bg-[#1388ad] text-white' : 'text-gray-300 hover:bg-white/5'}`} data-id="element-185">
                          <OptionIcon className="w-4 h-4 flex-shrink-0" data-id="element-186" />
                          <span data-id="element-187">{option.label}</span>
                        </button>;
              })}
                  </div>}
              </div> : <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center border border-white/20 flex-shrink-0" data-id="element-188">
                <SelectedIcon className="w-4 h-4 text-white" data-id="element-189" />
              </div>}
          </div>
        </div>
        {/* Navigation - Flexible Height */}
        <nav className="flex-1 p-4 space-y-2 overflow-y-auto min-h-0" data-id="element-190">
          {menuItems.map(item => renderMenuItem(item, false))}
        </nav>
        {/* Footer - Fixed Height */}
        <div className="h-[72px] flex-shrink-0 p-4 border-t border-white/10 flex items-center" data-id="element-191">
          <button onClick={cycleMode} className="flex items-center gap-3 px-4 py-3 rounded-full transition-colors text-gray-300 hover:bg-white/5 w-full h-12" data-id="element-192">
            <ModeIcon className="w-4 h-4 flex-shrink-0" data-id="element-193" />
            <span className={`text-sm font-normal whitespace-nowrap transition-all duration-200 ${shouldExpand ? 'opacity-100 max-w-full' : 'opacity-0 max-w-0 overflow-hidden'}`} data-id="element-194">
              {getModeLabel()}
            </span>
          </button>
        </div>
      </div>
    </>;
}